module.exports = __webpack_public_path__ + "img/p2.085df4a7.png";